import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import ForgotPasswordForm from 'forms/ForgotPasswordForm'
import Paper from 'components/Paper'
import Center from 'layout/Center'

import styles from './index.css'

import handleFormErrors from 'utils/handleFormErrors'

import AuthAPI from 'api/AuthAPI'
import { setToken } from 'utils/auth'


@withRouter
export default class ForgotPassword extends React.Component {
  
  static propTypes = {
  }

  state = {
    sent: false 
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  async submit(values) {
    const res = handleFormErrors(await AuthAPI.forgotPassword(values))
    this.setState({ sent: true })
  }

  render() {
    return (
      <Center>
        <Paper>
          { 
            this.state.sent == false && 
              <ForgotPasswordForm 
                form={'ForgotPasswordForm'}
                onSubmit={this.submit}
                />
          }
          { 
            this.state.sent &&
              <div className={styles.CheckYourEmailDiv}> 
                <h1>Reset link sent</h1>
                <span className={styles.Hint}>
                  Please check your inbox
                </span>
              </div>
          }
        </Paper>
      </Center>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/index.jsx